export enum CustomerType {
    general = 'general',
    straatwerk = 'straatwerk',
    drillings = 'drillings',
}
